import { createMutationHook, collapseParams } from '../../client';
import { setHvacMode } from '../../services/smartthermostat/ModeService';

export const useModeSetHvacMode = createMutationHook(
  collapseParams(collapseParams(setHvacMode, 'requestBody', 'data'), 'data', 'mode'),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['mode'] },
    ],
  },
);
